module.exports = __webpack_public_path__ + "71b69c62cb932a83ec44b02b233ee51f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00004DB0.png
// module id = 1567
// module chunks = 0